import PropTypes from "prop-types";

export default function Dollar({ children, toFixed = 2 }) {
  const value = Number(children);
  const isNegative = value < 0;
  const hasDecimals = Math.abs(value) % 1 > 0;
  const valueWithDecimals = Math.abs(value).toLocaleString("en-US", {
    minimumFractionDigits: hasDecimals ? toFixed : 0,
    maximumFractionDigits: toFixed,
  });
  return isNegative ? `$ (${valueWithDecimals})` : `$${valueWithDecimals}`;
}

Dollar.propTypes = {
  children: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    .isRequired,
  toFixed: PropTypes.number,
};
